import React, { useEffect, useState } from "react";
import axios from "axios";
import WidgetCampagne from "../components/widget-campagne/WidgetCampagne";
import "../pages/Home.scss";
import { CAMPAIGNS_TYPE } from "../types/campaigns";
function App() {
    const [testWidgetCampagne, setWidgetCampagne] = useState([]); //Widget Campagne
    useEffect(() => {
        fetchData2();
    }, []);
    async function fetchData2() {
        // /campaigns-data/<store_id>-<language_id>-by-<type|idCampaign>.json
        console.log("Id negozio" + window.storeID);
        console.log("Id lingua" + window.linguaID);
        //https://stores-pinko.retailtune.com/campaigns-data/1-1-by-type.json
        const p1 = axios
            .get("https://test-danjohn.retailtune.com/campaigns-data/" + window.storeID + "-" + window.linguaID + "-by-type.json")
            .then(res => {
            console.log(res.data.campaigns);
            setWidgetCampagne(res.data.campaigns);
        })
            .catch(e => console.error(e));
    }
    return (React.createElement("div", { className: "filteredList" },
        React.createElement(WidgetCampagne, { key: 0, data: testWidgetCampagne.filter(campaign => campaign.type === "promotion" && campaign.title === "" && campaign.text === ""), campaignType: CAMPAIGNS_TYPE.IMAGE }),
        React.createElement(WidgetCampagne, { key: 1, data: testWidgetCampagne.filter(campaign => campaign.type === "promotion" && campaign.title !== "" && campaign.text !== ""), campaignType: CAMPAIGNS_TYPE.TEXT_IMAGE })));
}
export default App;
